import axios from "axios/index";
import qs from "querystring";

export default class Logger {
    constructor(loggerUrl) {
        this.loggerUrl = loggerUrl;
    }

    critical(message, data) {
        axios.post(
            this.loggerUrl,
            qs.stringify({data: JSON.stringify({message: message, data})}),
            {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            });
    }
}



// WEBPACK FOOTER //
// ./src/helpers/Logger.js